import React, { useState } from "react";
import styles from "./CardDetailContent.module.css";
import AddIcon from "@material-ui/icons/Add";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import Rating from "@material-ui/lab/Rating";
import RemoveIcon from "@material-ui/icons/Remove";
import { Grid, InputBase, Button, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import toVND from "shared/func/toVND";
import { fetchAddToCartInLocalStorage } from "redux/ActionCreators/CartActionCreators";
import { useDispatch } from "react-redux";
import { fetchInCreateCountByID } from "../../../redux/ActionCreators/CartActionCreators";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";
import PhoneIcon from "@material-ui/icons/Phone";
import FacebookIcon from "@material-ui/icons/Facebook";
import MessageIcon from "@material-ui/icons/Message";

const CardDetailContent = (props) => {
  const {
    id,
    title,
    rating,
    price,
    priceDiscount,
    description,
    imgPathRegex,
    numberProductSold,
  } = props;
  const dispatch = useDispatch();

  const [purchaseQuantity, setPurchaseQuantity] = useState(1);

  const handleAddShoppingCart = () => {
    dispatch(
      fetchAddToCartInLocalStorage(
        id,
        title,
        priceDiscount ? priceDiscount : price,
        toArrayImageFromImageRegex(imgPathRegex)[0]
      )
    );
    for (let i = 1; i < purchaseQuantity; ++i) {
      dispatch(fetchInCreateCountByID(id));
    }
  };
  return (
    <div className={styles.container}>
      <div className={`${styles.title} ${styles.item}`}>
        <p>{title}</p>
      </div>

      <p>({numberProductSold} sản phẩm đã bán)</p>
      <div className={`${styles.rating} ${styles.item}`}>
        <Rating name="simple-controlled" value={rating} readOnly size="small" />
      </div>
      <div className={`${styles.price} ${styles.item}`}>
        <div>
          <Typography
            variant="body1"
            color="textSecondary"
            component="p"
            className={styles.price_first}
          >
            {priceDiscount ? toVND(price) : null}
          </Typography>
          <p className={styles.price_last}>
            {!price
              ? "Liên hệ với chúng tôi!"
              : priceDiscount
              ? toVND(priceDiscount)
              : toVND(price)}
          </p>
          <p>
            {!price &&
              "(Chú ý: sản phẩm có thể có nhiều kích thước - màu - chất lượng khác nhau. Vì vậy,  mong các bạn có thể ibx yêu cầu vào shop để shop có thể gửi cho bạn lựa chọn sản phẩm ưng ý nhất!)"}
          </p>
        </div>
      </div>

      <div
        className={`${styles.description} ${styles.item}`}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      ></div>

      <div className={`${styles.action_container} ${styles.item}`}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <span className={`${styles.count_container}`}>
              <Button
                className={styles.btn_count}
                size="large"
                onClick={() => {
                  return purchaseQuantity > 1
                    ? setPurchaseQuantity(purchaseQuantity - 1)
                    : null;
                }}
              >
                <RemoveIcon />
              </Button>
              <InputBase
                className={styles.input_count}
                value={purchaseQuantity}
              />

              <Button
                className={styles.btn_count}
                size="large"
                onClick={() => {
                  setPurchaseQuantity(purchaseQuantity + 1);
                }}
              >
                <AddIcon />
              </Button>
            </span>
          </Grid>

          <Grid item xs={12} sm={6}>
            <span className={styles.btn_add_to_cart_container}>
              {price ? (
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className={styles.btn_add_to_cart}
                  startIcon={<ShoppingBasketIcon />}
                  onClick={handleAddShoppingCart}
                >
                  Thêm Vào Giỏ
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className={styles.btn_add_to_cart}
                  startIcon={<MessageIcon />}
                  href={process.env.REACT_APP_ADMIN_MESSENGER}
                  target="_blank"
                >
                  Liên hệ về SP
                </Button>
              )}
            </span>
          </Grid>
        </Grid>
      </div>

      <div className={`${styles.item}`}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              size="large"
              color="primary"
              startIcon={<PhoneIcon />}
              href={`tel:${process.env.REACT_APP_ADMIN_PHONE}`}
              className={`${styles.btn_information_phone} ${styles.btn_information}`}
            >
              {process.env.REACT_APP_ADMIN_PHONE}
            </Button>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              size="large"
              color="primary"
              startIcon={<FacebookIcon />}
              href={`${process.env.REACT_APP_ADMIN_FACEBOOK}`}
              className={styles.btn_information}
            >
              facebook
            </Button>
          </Grid>
        </Grid>
      </div>

      <div className={`${styles.item} ${styles.return_policies_container}`}>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" gutterBottom>
              Chính sách bán hàng:
            </Typography>
            <ul>
              <li>
                <Typography variant="body2" gutterBottom>
                  Bảo Hành 12 Tháng
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Giao hàng thông qua{" "}
                  <a href="https://viettelpost.com.vn/en/">viettelpost</a>
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Được kiểm tra hàng khi nhận hàng.
                </Typography>
              </li>
              <li>
                <Typography variant="body2" gutterBottom>
                  Thanh toán khi nhận hàng.
                </Typography>
              </li>
            </ul>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

CardDetailContent.propTypes = {
  title: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  priceDiscount: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

export default CardDetailContent;
